import React from 'react';

// 🛍️ "Mostrar en el catálogo" (productos.activo). Apagado = las clientas no lo ven
// en el catálogo en línea ni en el catálogo de Meta; en Kontrol se sigue vendiendo igual.
export default function InterruptorCatalogo({ valor, onChange, deshabilitado = false, estilo = {} }) {
  const encendido = valor !== false;
  return (
    <label style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', borderRadius: '10px', cursor: deshabilitado ? 'not-allowed' : 'pointer',
      border: `1px solid ${encendido ? '#BBF7D0' : '#E5E7EB'}`, background: encendido ? '#F0FDF4' : '#F9FAFB', ...estilo }}>
      <span style={{ flex: 1 }}>
        <b style={{ display: 'block', fontSize: '14px', color: '#1F2937' }}>{encendido ? '🛍️ Mostrar en el catálogo' : '🙈 Oculto del catálogo'}</b>
        <span style={{ fontSize: '12px', color: '#6B7280' }}>
          {encendido ? 'Tus clientas lo ven en tu catálogo en línea.' : 'Tus clientas no lo ven. Lo puedes seguir vendiendo desde Kontrol.'}
        </span>
      </span>
      <input type="checkbox" role="switch" checked={encendido} disabled={deshabilitado} onChange={(e) => onChange(e.target.checked)}
        aria-label="Mostrar en el catálogo" style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }} />
      <span aria-hidden="true" style={{ flex: '0 0 auto', width: '46px', height: '26px', borderRadius: '999px', position: 'relative', transition: 'background .2s',
        background: encendido ? 'var(--k-verde,#059669)' : '#D1D5DB', opacity: deshabilitado ? 0.6 : 1 }}>
        <span style={{ position: 'absolute', top: '3px', left: encendido ? '23px' : '3px', width: '20px', height: '20px', borderRadius: '50%', background: 'white',
          boxShadow: '0 1px 3px rgba(0,0,0,.25)', transition: 'left .2s' }} />
      </span>
    </label>
  );
}
